'use strict';

import {applicationModel} from "../../models/applicationmodel.js";
import {fieldModel} from "../../models/fieldmodel.js";

export class ApplicationInfoCtrl
{
	$scope;
	$filter;
	jsDataService;
	$mdDialog;
	item = {};
	fieldCfg = {};
	
	constructor($scope, $filter, jsDataService, $mdDialog){
		'ngInject';
		this.$scope = $scope;
		this.$filter = $filter;
		this.jsDataService = jsDataService;
		this.$mdDialog = $mdDialog;
		this.classif = this.jsDataService.get('cfgClassif', {});
		this.item = new applicationModel(jsDataService.get('applicationBase', {}), $filter, jsDataService);
		this.makeFieldCfg(this.item.fields);
	}
	
	makeFieldCfg(fields){
		if(typeof(fields) !== 'undefined'){
			for(let fld of Object.values(fields)){
				this.fieldCfg[fld.name] = new fieldModel(fld);
			}
		}
	}
	
	isField(name){
		return (typeof(this.fieldCfg[name]) !== 'undefined');
	}
	
	getFieldTitle(name){
		if(this.isField(name)){
			return this.fieldCfg[name].title;
		}
		return '';
	}
	
	applicationSubmit(ev){
		if(this.item.status < 1){
			this.$mdDialog.show({
				controller: ["$scope", "$mdDialog", "item", this.submitDialogCtrl],
				templateUrl: 'application/application_submit.html',
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose:false,
				fullscreen: true,
				locals: {
					item: this.item
				}
			}).then((results) => {
				console.log('dialog close', results);
			}, () => {});
		}
	}
	
	applicationRevoke(ev){
		if(this.item.status > 0 && typeof(this.item.revoke_url) !== 'undefined' && this.item.revoke_url !== ''){
			const confirmTexts = this.jsDataService.get('revokeConfirmTexts');
			const confirm = this.$mdDialog.confirm()
				.title(confirmTexts.title)
				.htmlContent(confirmTexts.content)
				.ariaLabel(confirmTexts.title)
				.targetEvent(ev)
				.ok(confirmTexts.ok)
				.cancel(confirmTexts.cancel);
			this.$mdDialog.show(confirm).then(() => {
				this.$scope.basicHttpConfigProcess({
					url: this.item.revoke_url,
					method: 'GET',
					responseType: 'json',
				}).then((results) => {});
			}, () => {});
		}
	}

	applicationRemove(ev){
		if(this.item.status == 0 && typeof(this.item.remove_url) !== 'undefined' && this.item.remove_url !== ''){
			const confirmTexts = this.jsDataService.get('removeConfirmTexts');
//			const applicationPageUrl = this.jsDataService.get('applicationPageUrl');
			const confirm = this.$mdDialog.confirm()
				.title(confirmTexts.title)
				.htmlContent(confirmTexts.content)
				.ariaLabel(confirmTexts.title)
				.targetEvent(ev)
				.ok(confirmTexts.ok)
				.cancel(confirmTexts.cancel);
			this.$mdDialog.show(confirm).then(() => {
				this.$scope.basicHttpConfigProcess({
					url: this.item.remove_url,
					method: 'GET',
					responseType: 'json'
				}).then((results) => {
					if(results.data.success){
//						window.location.href = applicationPageUrl;
					}
				});
			}, () => {});
		}
	}
	
	applicationStatus(ev){
		if(this.item.status > 0){
			this.$mdDialog.show({
				controller: ["$scope", "$mdDialog", "jsDataService", "item", this.statusDialogCtrl],
				templateUrl: 'application/application_status.html',
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose:false,
				fullscreen: true,
				locals: {
					item: this.item
				}
			}).then((results) => {
				this.$scope.$root.basicHttpConfigProcess({
					url: this.item.status_url,
					method: 'POST',
					responseType: 'json',
					data: results
				});
			}, () => {});
		}
	}
	
	submitDialogCtrl($scope, $mdDialog, item){
		/**
		 * 0 - klaida kai nera galiybes siusti
		 * 1 - pranesimas kas bus daroma
		 * 2 - loaderis kad vyksta
		 * 3 - atsakymas su klaidomis
		 * 4 - pranesimas apie sekminga validacija ir mygtukas submitinimui
		 * 5 - pranesimas apie sekminga submitinima ir mygtukas uzdaryti 
		 *  - esant klaidai, klaida parodoma klaidu vietoje o dialogas uzdaromas
		 */
		$scope.state = 0;
		$scope.reloadOnClose = false;
		
		$scope.item = item;
		
		if(typeof($scope.item.submit_url) !== 'undefined' && $scope.item.submit_url !== ''){
			$scope.state = 1;
		}
		
		$scope.responseData;
		
		$scope.startValidate = function(){
			if($scope.state > 0){
				$scope.state = 2;
				$scope.$root.basicHttpConfigProcess({
					url: $scope.item.submit_url + '/validate',
					method: 'GET',
					responseType: 'json',
				}).then((results) => {
					if(typeof(results.data.close) !== 'undefined'){
						$scope.close();
					}
					else{
						if(!results.data.success){
							$scope.state = 3;
							$scope.responseData = Object.values(results.data.errordata);
						}
						else{
							$scope.state = 4;
						}
					}
				});
			}
		};
		
		$scope.startSubmit = function(){
			if($scope.state > 0){
				$scope.state = 2;
				$scope.$root.basicHttpConfigProcess({
					url: $scope.item.submit_url + '/submit',
					method: 'GET',
					responseType: 'json',
				}).then((results) => {
					if(typeof(results.data.close) !== 'undefined'){
						$scope.close();
					}
					else{
						if(results.data.success){
							$scope.state = 5;
							$scope.reloadOnClose = true;
							$scope.responseData = results.data.inform;
						}
						else{
							$scope.close();
						}
					}
				});
			}
		};
		
		
		
		$scope.getSectionFormatedTitle = function(section){
			let nr = '';
			if(section.numbered == 1 && section.number !== ''){
				nr = section.number + ' ';
			}
			return nr + section.title;
		};
		
		$scope.close = function() {
			if($scope.reloadOnClose){
				window.location.reload(true);
			}
			$mdDialog.cancel();
		};
	}
	
	statusDialogCtrl($scope, $mdDialog, jsDataService, item){
		$scope.classif = jsDataService.get('cfgClassif', []);
		$scope.item = angular.copy(item);
		
		$scope.close = function() {
			$mdDialog.cancel();
		};
		
		$scope.save = function() {
			$mdDialog.hide($scope.item);
		};
	}
}